<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import StatementEdit from "$app/Pages/Plans/OnePageView/StatementEdit.svelte"
  import { Plus } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  import empty_img from "@images/onboarding/empty.png"

  let statement: StatementType = $derived(
    appStore.statements
      .filter((st) => st.section_type === "BrandPurpose")
      .sort((a, b) => a.position - b.position)[0] || null
  )

  let openEditModal = $state(false)
  let openViewModal = $state(false)
  let editStatus = $state("")

  const activeStep = () => {
    if (
      appStore.onboarding.completed_onboarding ||
      appStore.onboarding.onboarding_steps.invite_members ||
      (appStore.onboarding.skipped_onboarding && statement)
    ) {
      return true
    }

    return false
  }
</script>

<div
  class="{activeStep()
    ? 'bg-white'
    : 'bg-gray-400 opacity-30'} overflow-hidden shadow h-72"
  data-name="brand-purpose"
>
  <div class="px-4 py-5 sm:px-6 relative">
    <div class="flex items-center justify-center w-full">
      <h3 class="leading-6 font-semibold text-black text-center">
        Brand Purpose
      </h3>
    </div>
    {#if activeStep() && statement && appStore.update_core}
      <div class="w-12 absolute top-2 right-2">
        <button
          type="button"
          onclick={() => (openEditModal = true)}
          class="btn-link"
          data-name="edit-brand-purpose"
        >
          EDIT
        </button>
      </div>
    {/if}
  </div>

  <div class="flex flex-col px-3 mb-3">
    {#if statement}
      <button
        class="flex justify-center cursor-pointer h-32 overflow-hidden items-center"
        onclick={() => (openViewModal = true)}
        tabindex="0"
      >
        {#if statement.symbol_url && statement.symbol_url.length > 0}
          <img
            src={statement.symbol_url}
            alt={statement.name}
            class="max-h-32"
          />
        {/if}
      </button>
      <button
        class="justify-center py-3 text-center cursor-pointer"
        onclick={() => (openViewModal = true)}
      >
        {statement.name}
      </button>
    {:else if activeStep() && appStore.update_core}
      <div class="flex flex-col justify-center items-center">
        <img src={empty_img} class="w-24 h-auto" alt="No Brand Purpose" />

        <button
          class="mt-6 border border-gray-200 rounded-lg py-2 px-3 flex bg-green-600 hover:bg-green-500 hover:text-white text-gray-50 items-center justify-center"
          onclick={() => (openEditModal = true)}
        >
          <Plus class="size-4" />
          <div class="text-center text-sm ml-1">Create your Brand Purpose</div>
        </button>
      </div>
    {:else}
      <div class="w-full">
        <div class="flex flex-col justify-center items-center mt-4">
          <img src={empty_img} class="w-28 h-auto" alt="No Brand Purpose" />
          <p class="text-base mt-4">No Brand Purpose</p>
        </div>
      </div>
    {/if}
  </div>
</div>

<Modal bind:open={openEditModal} large={true}>
  <StatementEdit
    section="BrandPurpose"
    initialStatus={editStatus}
    onupdate={(st) => {
      if (st.length == 1) {
        appStore.updateStatement(st)
      } else {
        appStore.updateStatements(st, "BrandPurpose")
      }

      statement =
        appStore.statements
          .filter((st) => st.section_type === "BrandPurpose")
          .sort((a, b) => a.position - b.position)[0] || null
    }}
  />
</Modal>

<Modal bind:open={openViewModal} large={false}>
  <div class="p-4 min-w-2xl max-w-3xl">
    <h2 class="font-bold text-xl text-center mb-4">{statement.name}</h2>

    <div class="flex gap-3 mt-8">
      <div>
        <img
          src={statement.symbol_url}
          alt={statement.name}
          class="max-h-32"
          style="max-width:180px"
        />
      </div>

      <p class="px-4 ProseMirror">
        {@html statement.description || "<i>No Description Entered</i>"}
      </p>
    </div>
  </div>
</Modal>
